// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-Links_cls1__dGKBM","cls2":"VeloLogoPage-Links_cls2__XN457 VeloLogoPage-Links_cls1__dGKBM"};